var React = require('react');

function FirstTriangleCS (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M55.8329 58.431L47.593 13.8706L105.905 55.0221L55.8329 58.431Z","fill":"#6C21E4","key":0}),React.createElement("path",{"d":"M23.5983 80.897L47.6445 13.8336L55.8545 58.3395L23.5983 80.897Z","fill":"#651DD8","key":1}),React.createElement("path",{"d":"M23.5977 80.8965L55.8311 58.3549L105.902 55.0228L23.5977 80.8965Z","fill":"#5915C7","key":2})]);
}

FirstTriangleCS.defaultProps = {"width":"106","height":"103","viewBox":"0 0 106 103","fill":"none"};

module.exports = FirstTriangleCS;

FirstTriangleCS.default = FirstTriangleCS;
